// extracted by mini-css-extract-plugin
export default {"wrapper":"Ey","subscription":"Fy","select_item":"Gy","is_selected":"Hy","otb":"Iy","radio":"Jy","first_row":"Ky","prices":"Ly","italic":"My","info_wrapper":"Ny","first_month":"Oy","separator":"Py","checkmark":"Qy","bullets":"Ry","bullet":"Sy","checkmarkText":"Ty","button":"Uy","discountBadge":"Vy"};
    if(module.hot) {
      // 1714442369168
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  